export const PAGE_NAME = 'follow-up-automations'

export const FOLLOW_UP_AUTOMATIONS_PATH =
  '/pga-coach/settings/follow-up-automations'

export const MESSAGE_MAX_LENGTH = 2000

export const DELAY_OPTIONS = [0, 1, 2, 3, 5, 7, 14, 30]

// `when` finishes "Sends <delay> ..."; `immediate` replaces the whole sentence
// when the rule sends with no delay and reads better without "right away".
export const RULE_COPY = {
  CANCELED: {
    title: 'Canceled a booking',
    when: 'after a student cancels and hasn’t rebooked',
  },
  NEW: {
    title: 'First-time students',
    when: 'after a student’s first lesson if they haven’t booked another',
  },
  DUE: {
    title: 'Due to rebook',
    when: 'after a student passes their usual booking pace',
    immediate: 'Sends when a student passes their usual booking pace.',
  },
  LAPSED: {
    title: 'Lapsed students',
    when: 'after a student goes a while without booking',
    immediate: 'Sends when a student hasn’t booked in a while.',
    editDescription:
      'Automatically sends when a student hasn’t booked in a while. You can also use this message as a starting point when following up yourself.',
  },
}

export const resultTitle = trigger =>
  RULE_COPY[trigger]?.title ?? 'Other follow-ups you sent'

export const formatDelay = days => {
  if (days === 0) return 'Right away'
  if (days === 1) return '1 day'
  return `${days} days`
}

export const describeRule = (trigger, delayDays) => {
  const { when, immediate } = RULE_COPY[trigger]
  if (delayDays === 0) return immediate ?? `Sends right away ${when}.`
  return `Sends ${formatDelay(delayDays)} ${when}.`
}

export const lowerFirst = text => text.charAt(0).toLowerCase() + text.slice(1)

// pga-backend builds sendSchedule as "Weekdays around 6 PM, your local time"
// (OutreachAutomationsType#send_schedule), so callers can say "send on ...":
// -> "weekdays around 6 PM local time"
export const describeSchedule = sendSchedule =>
  lowerFirst(sendSchedule).replace(', your ', ' ')
